import { render, staticRenderFns } from "./FAQsTable.vue?vue&type=template&id=7cc4f276&"
import script from "./FAQsTable.vue?vue&type=script&lang=js&"
export * from "./FAQsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports